import { styled } from '@mui/material';
import { IconTypography } from '@procureai/ui-mui';

export const Description = styled(IconTypography)(({ theme }) => ({
  flexShrink: 100000,
  minWidth: 20,
  color: theme.palette.grey['300'],
}));
